import { Component, PropsWithChildren } from 'react';
import { Container } from 'react-bootstrap';

export default class BasicLayout extends Component<PropsWithChildren<{}>> {
    render() {
        const { children } = this.props;
        return (
            <div className="base-layout">
                <Container fluid={true}>{children}</Container>
            </div>
        );
    }
}
